import script from "./UpcomingOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./UpcomingOverview.vue?vue&type=script&setup=true&lang=js"

import "./UpcomingOverview.vue?vue&type=style&index=0&id=16407ee4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16407ee4"]])

export default __exports__